const products = [
  {
    id: "vpn",
    name: "TIAS VPN",
    tag: "Security",
    tagline: "Your Privacy, Uncompromised",
    description:
      "TIAS VPN delivers enterprise-grade encryption for everyday iOS users. Browse, stream, and communicate with the confidence that your data stays private — at home, at work, or on public networks.",
    highlights: [
      "Military-grade AES-256 encryption",
      "No-logs privacy policy",
      "One-tap connect & disconnect",
      "Global server infrastructure",
      "Kill switch protection",
      "iOS 15+ optimized performance",
    ],
    image:
      "https://public.readdy.ai/ai/img_res/35fb7be074b9c06af73ec65297a97340.jpg",
    dark: true,
  },
  {
    id: "cleaner",
    name: "TIAS Cleaner",
    tag: "Performance",
    tagline: "Speed Up Your iPhone",
    description:
      "TIAS Cleaner intelligently identifies and removes junk files, duplicate photos, and unnecessary cached data — freeing up valuable storage and giving your iPhone a fresh, fast feel.",
    highlights: [
      "Smart junk file detection",
      "Duplicate photo remover",
      "Cache & temp file cleanup",
      "Storage usage analyzer",
      "Large file scanner",
      "Safe, non-destructive cleaning",
    ],
    image:
      "https://readdy.ai/api/search-image?query=A%20minimalist%20clean%20sparkle%20and%20broom%20icon%20representing%20iPhone%20storage%20cleaner%20app%20on%20a%20warm%20light%20cream%20off-white%20background%2C%20iOS%20mobile%20performance%20optimization%20concept%20art%2C%20subtle%20warm%20tones%2C%20premium%20modern%20design%2C%20soft%20light%20and%20shadow%2C%20fresh%20clean%20aesthetic%2C%20professional%20product%20photography%20style%2C%20minimal%20composition&width=600&height=600&seq=cleaner001&orientation=squarish",
    dark: false,
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="w-full py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-amber-600 text-xs font-semibold uppercase tracking-widest">Our Products</span>
          <h2 className="mt-3 text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
            Built for iOS. Built for You.
          </h2>
          <p className="mt-4 text-gray-500 max-w-xl mx-auto text-base">
            Two essential tools engineered to keep your iPhone secure, clean, and
            running at its best.
          </p>
        </div>

        {/* Products */}
        <div className="flex flex-col gap-8">
          {products.map((product, index) => (
            <div
              key={product.id}
              className={`rounded-2xl overflow-hidden grid lg:grid-cols-2 ${
                product.dark ? "bg-[#111111] text-white" : "bg-[#F8F6F2] text-gray-900"
              }`}
            >
              {/* Image — alternating order */}
              <div
                className={`relative w-full h-72 lg:h-auto ${
                  index % 2 === 1 ? "lg:order-2" : ""
                }`}
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content */}
              <div
                className={`p-10 lg:p-14 flex flex-col justify-center ${
                  index % 2 === 1 ? "lg:order-1" : ""
                }`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <span
                    className={`text-xs font-semibold uppercase tracking-widest px-3 py-1 rounded-full ${
                      product.dark
                        ? "bg-amber-500/20 text-amber-400"
                        : "bg-amber-100 text-amber-700"
                    }`}
                  >
                    {product.tag}
                  </span>
                </div>
                <h3 className="text-3xl lg:text-4xl font-bold mb-2">{product.name}</h3>
                <p
                  className={`text-base font-medium mb-4 ${
                    product.dark ? "text-amber-400" : "text-amber-600"
                  }`}
                >
                  {product.tagline}
                </p>
                <p
                  className={`text-sm leading-relaxed mb-8 ${
                    product.dark ? "text-white/60" : "text-gray-600"
                  }`}
                >
                  {product.description}
                </p>

                {/* Highlights */}
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  {product.highlights.map((h) => (
                    <li key={h} className="flex items-center gap-2 text-sm">
                      <span
                        className={`w-4 h-4 flex items-center justify-center rounded-full flex-shrink-0 ${
                          product.dark ? "bg-amber-500/20 text-amber-400" : "bg-amber-100 text-amber-600"
                        }`}
                      >
                        <i className="ri-check-line text-xs" />
                      </span>
                      <span className={product.dark ? "text-white/70" : "text-gray-700"}>{h}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
